<template>
  <div class="finAcademy">
    <div v-if="$route.name === 'finAcademy'">
      <fin-content-section :style="'background-color:' + $finColors.background"
                           class="pt-9">
        <template>
          <v-container>

            <fin-academy-intro/>

            <v-row class="ma-0">
              <v-col cols="12" md="8">
                <fin-academy-demo-tool/>
              </v-col>
              <v-col cols="12" md="4">
                <fin-academy-lexicon/>
              </v-col>
            </v-row>

            <v-row class="pt-12">
              <v-col cols="12">
                <fin-academy-media-library/>
              </v-col>
            </v-row>

          </v-container>
        </template>
      </fin-content-section>
    </div>

    <router-view v-else/>
  </div>
</template>

<script>
import FinContentSection from '@/components/pages/ContentSection'
import FinAcademyMediaLibrary from "@/components/pages/finAcademy/AcademyMediaLibrary"
import FinAcademyDemoTool from "@/components/pages/finAcademy/AcademyDemoTool"
import FinAcademyIntro from "@/components/pages/finAcademy/AcademyIntro"
import FinAcademyLexicon from "@/components/pages/finAcademy/AcademyLexicon"

export default {
  name: 'finAcademy',
  components: {
    FinAcademyLexicon,
    FinAcademyIntro,
    FinAcademyDemoTool,
    FinAcademyMediaLibrary,
    FinContentSection
  },
}
</script>

<style lang="scss" scoped>

</style>
